import React from "react";
//import "./style.scss";
import RedCross from "../../Assets/red-cross.svg";

import AMStorageAPI from "./graphic-api";
import plus from "../../Assets/plus.svg";
import { CustomToast } from "../custom-toast/CustomToast";
import axios from "axios";
import { sliceString } from "../../util/helpers/funcHelper";
class APKPicker extends React.Component {
  /*

        Status: 
            0: Select File
            1: Uploading
            2: Uploaded

            
    */

  constructor(props) {
    super(props);
    this.state = {
      status: 0,
      progress: 0,
      name: "",
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken: "",
      size: 0,
      hasConnection: "",
    };
    this.selectedFileData = undefined;
    this.signal = axios.CancelToken.source();
    this.isApiCancelled = false;
  }

  componentDidUpdate() {
    if (this.state.hasConnection === "" && !navigator.onLine) {
      this.setState({ hasConnection: "false" });
      if (this.state.sasUrl) {
        this.resetFile();
        this.signal.cancel();
      }
    } else if (this.state.hasConnection === "false" && navigator.onLine) {
      this.signal = axios.CancelToken.source();
      this.setState({ hasConnection: "true" });
    } else if (this.state.hasConnection === "true" && !navigator.onLine) {
      this.setState({ hasConnection: "false" });
      this.showError("Internet disconnected");
      this.resetFile();
      this.signal.cancel();
    }
  }

  generateSAS() {
    var api = new AMStorageAPI();
    api
      .generateGraphicSAS(this.props.applicationId, {
        type: "apk",
        fileName: `${Date.now()}_${this.state.name}`,
      })
      .then((response) => {
        this.setState({
          sasFileName: response.data.data.fileName,
          sasToken: response.data.data.token,
          sasUrl: response.data.data.url,
          sasUrlWithoutToken: response.data.data.url.replace(
            "?" + response.data.data.token,
            ""
          ),
        });

        console.log({
          sasFileName: response.data.data.fileName,
          sasToken: response.data.data.token,
          sasUrl: response.data.data.url,
          sasUrlWithoutToken: response.data.data.url.replace(
            "?" + response.data.data.token,
            ""
          ),
        });
        this.isApiCancelled = false;
        this.uploadFile();
      })
      .catch((error) => {
        console.log(error);
        CustomToast(error.response.data.message);
        this.resetFile();
      });
  }

  uploadFile() {
    var api = new AMStorageAPI();

    api
      .uploadFile(
        this.signal,
        this.state.sasUrl,
        this.selectedFileData,
        (progress) => {
          progress = Math.floor(progress);
          this.setState({ progress: progress });
        }
      )
      .then((response) => {
        this.setState({ status: 2 });
        this.props.onComplete({
          fileName: this.state.sasFileName,
          url: this.state.sasUrlWithoutToken,
          size: this.state.size,
        });
      })
      .catch((error) => {
        this.props.onComplete({ fileName: "", url: "", size: 0 });
        if (!this.isApiCancelled) {
          return this.showError("Unable to upload please try uploading again");
        }
      });
  }

  showError(msg) {
    this.resetFile();
    this.setState({ errorMsg: msg });
  }

  selectFile() {
    var input = document.createElement("input");
    input.type = "file";
    input.accept = this.props?.appOs === "ios" ? ".ipa" : ".apk";
    input.onchange = (e) => {
      var file = e.target.files[0];
      var fileExtension = "";

      if (file.name.lastIndexOf(".") > 0) {
        fileExtension = file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        );
      }
      if (this.props.appOs === "ios") {
        if (fileExtension.toLowerCase() !== "ipa") {
          return this.showError("Only ipa files are allowed to upload");
        }
      } else {
        if (fileExtension.toLowerCase() !== "apk") {
          return this.showError("Only apk files are allowed to upload");
        }
      }

      this.selectedFileData = file;
      this.resetFile();

      this.setState({
        status: 1,
        name: file.name,
        size: file.size,
      });

      //this.uploadFile();
      this.generateSAS();
      // this.startTimer();
    };

    input.click();
  }

  resetFile() {
    this.setState({
      status: 0,
      progress: 0,
      name: "",
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken: "",
      size: 0,
    });
    this.props.onComplete({ fileName: "", url: "" });
  }

  render() {
    const comp = () => {
      switch (this.state.status) {
        case 1:
          return (
            <div className="file-uploading-container">
              <div className="progress-wrapper">
                <div className="d-flex d-flex-column text-left">
                  <span className="text-gray">Uploading...</span>
                  <div className="upload-percent">
                    {this.state.name} {this.state.progress}%
                  </div>
                </div>
                <div className="progress-cancel p-0 text-end ">
                  <img
                    alt=""
                    onClick={(e) => {
                      this.isApiCancelled = true;
                      this.signal.cancel();
                      this.resetFile();
                      this.signal = axios.CancelToken.source();
                    }}
                    className="red-cross c-pointer"
                    src={RedCross}
                  />
                </div>
              </div>
              <div className="progress-bar">
                <div
                  className="progress-filled"
                  style={{ width: `${this.state.progress}%` }}
                ></div>
              </div>
            </div>
          );
        case 2:
          return (
            <div className="file-uploaded-container">
              <div className="container">
                {sliceString(0, 22, this.state.name, true)}
              </div>
              <div className="container p-0 text-end">
                <img
                  alt=""
                  onClick={(e) => this.resetFile()}
                  className="red-cross"
                  src={RedCross}
                />
              </div>
            </div>
          );

        default:
          return (
            <div
              className="file-upload-container"
              onClick={(e) => this.selectFile()}
            >
              {this.props.showplus ? (
                <img
                  src={plus}
                  alt="logo"
                  className="mr-1"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              ) : null}
              {this.props.text}
            </div>
          );
      }
    };

    return (
      <React.Fragment>
        {comp()}
        <span className="file-upload-error red">{this.state.errorMsg}</span>
      </React.Fragment>
    );
  }
}

export default APKPicker;
